import { Mic } from "lucide-react";
import { useVoice, LANGS } from "@/context/VoiceContext";
import { WaveDivider, Reveal } from "@/components/primitives";
import { voiceNav } from "@/config";

export default function VoiceNav() {
  const { lang, setLang, micState, toggleListening, supported, setHelpOpen } = useVoice();
  const listening = micState === "listening";

  return (
    <div data-testid="voice-nav" className="relative bg-noir pt-10">
      <div className="relative flex items-center" aria-hidden="true">
        <div className="hairline flex-1" />
        <WaveDivider listening={listening} className="mx-5 w-[min(60vw,420px)]" />
        <div className="hairline flex-1" />
      </div>

      <Reveal className="mx-auto flex max-w-3xl flex-col items-center gap-5 px-6 py-14 text-center sm:px-8">
        <div className="flex flex-wrap items-center justify-center gap-3">
          <p className="font-serif text-xl text-cream/90 sm:text-2xl">{voiceNav.prompt}</p>
          {supported && (
            <button
              data-testid="voicenav-mic"
              onClick={toggleListening}
              className={`grid h-10 w-10 place-items-center rounded-full border transition-colors ${listening ? "border-oxblood bg-oxblood text-cream" : "border-oxblood/60 text-cream hover:border-oxblood"}`}
              aria-label="Tap and speak"
            >
              <Mic className="h-4 w-4" />
            </button>
          )}
        </div>

        <p className="text-xs leading-relaxed text-gray2">
          {voiceNav.hints.map((h, i) => (
            <span key={h}>
              “{h}”{i < voiceNav.hints.length - 1 ? <span className="mx-2 text-cream/20">·</span> : null}
            </span>
          ))}
        </p>

        <div className="flex items-center gap-4">
          <div data-testid="lang-switch" className="flex items-center gap-1 rounded-full border border-cream/10 p-1">
            {LANGS.map((l) => (
              <button
                key={l.code}
                data-testid={`lang-${l.code}`}
                onClick={() => setLang(l.code)}
                aria-pressed={lang === l.code}
                className={`rounded-full px-3 py-1 font-mono text-[0.66rem] tracking-wider transition-colors ${lang === l.code ? "bg-gold/15 text-gold" : "text-gray2 hover:text-cream"}`}
              >
                {l.label}
              </button>
            ))}
          </div>
          <button data-testid="voicenav-help" onClick={() => setHelpOpen(true)} className="text-xs text-gray2 underline-offset-4 hover:text-gold hover:underline">
            What can I say?
          </button>
        </div>
      </Reveal>
    </div>
  );
}
